module.exports = __webpack_public_path__ + "img/Success-1.e614f280.png";